import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { AccountService } from 'src/app/services/account.service';
import { CustomValidators } from 'src/app/_helpers/customValidators';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.css'],
    standalone: true,
  imports: [CommonModule, ReactiveFormsModule, MatFormFieldModule, MatInput]
})
export class ForgotPasswordComponent implements OnInit {
  private accountService = inject(AccountService);


  error: string = null;
  forgotPasswordForm: UntypedFormGroup;
  submitted : boolean = false

  ngOnInit(): void {
    this.forgotPasswordForm = new UntypedFormGroup({
      'email': new UntypedFormControl(null, [CustomValidators.required, CustomValidators.email])
    });
  }

  onSubmit()
  {
    this.submitted = true;

    this.accountService.requestReset(this.forgotPasswordForm.get('email').value).subscribe(
      {
        next: (data) => {
          console.log(data)
        },
        error: (error) => {
          console.log(error.message);
        }
      }
    );
  }

  isFieldInvalid(): boolean {
    const field = this.forgotPasswordForm.get('email');
    return field && field.invalid && field.touched;
  }
}
